import { useSuspenseQuery } from "@apollo/client";
import { GET_POST_TO_EDIT } from "@/modules/feed/features/save-post/api/get-post-to-edit";
import { FieldsType } from "./types";

export function usePostToEdit({ postId }: { postId?: string }) {
  const { data } = useSuspenseQuery(GET_POST_TO_EDIT, {
    variables: {
      id: postId as string,
    },
    skip: !postId,
  });

  const initialValues: Partial<FieldsType> | undefined = postId
    ? {
        id: data?.getPostById.id,
        title: data?.getPostById.title,
        body: data?.getPostById.body || undefined,
        media: (data?.getPostById.media ?? []).map((m) => m.id),
      }
    : undefined;

  return {
    initialValues,
  };
}
